import { render, staticRenderFns } from "./ClientCompanyPage.vue?vue&type=template&id=15048456&"
import script from "./ClientCompanyPage.vue?vue&type=script&lang=js&"
export * from "./ClientCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports